import { useCallback } from 'react';
import { getStatus } from '../utils/ApiCall';

export const useMasterCpsEdit = (state, updateState, pathname) => {
  const handleEditResponseChange = useCallback(async (newValue, rowID, field) => {
    let status;
    if (field !== "offerStatus") {
      status = await getStatus(rowID, "master-cps");
    } else {
      status = newValue;
    }

    if (status === "PIXEL INTEGRATION") {
      const updatedRowsPixelI = state.pixelIntegration.map((row) => {
        if (+row.id === +rowID) {
          return { ...row, [`${field}`]: newValue };
        }
        return row;
      });
      updateState({ pixelIntegration: updatedRowsPixelI });
    } else if (status === "INACTIVE") {
      const updatedRowsInactives = state.inactive.map((row) => {
        if (+row.id === +rowID) {
          return { ...row, [`${field}`]: newValue };
        }
        return row;
      });
      updateState({ inactive: updatedRowsInactives });
    } else {
      const updatedRowsOfferID = state.offerID.map((row) => {
        if (+row.id === +rowID) {
          return { ...row, [`${field}`]: newValue };
        }
        return row;
      });
      updateState({ offerID: updatedRowsOfferID });
    }
  }, [state.pixelIntegration, state.inactive, state.offerID, updateState]);

  const updateBoard = useCallback((newData) => {
    const updatedRows = [...state.updateRows, newData];
    updateState({ updateRows: updatedRows });
  }, [state.updateRows, updateState]);

  return {
    handleEditResponseChange,
    updateBoard
  };
};